import styled from 'styled-components';

const EmptyText = styled.h3`
    color:rgb(74, 85, 104);
`

export default EmptyText;